(function () {
    'use strict';

    angular
        .module('wizard-future7.directives')
        .directive('validateDate', ValidateDate);

    function ValidateDate() {

        function testDateRegex(date) {
            if (!date)
                return true;

            let isDateValid = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/.test(date);

            return isDateValid;
        }

        function createMoment(date) {
            const dateReplaced = date ? date.replace(/[//"]/g, '-') : '';
            const dateSplitted = date ? dateReplaced.split("-") : '';

            let finalDate = `${dateSplitted[2]}-${dateSplitted[1]}-${dateSplitted[0]}`;

            return moment(finalDate);
        }

        function getAge(birthDate) {
            let date = createMoment(birthDate)

            return Math.floor((new Date() - new Date(date).getTime()) / 3.15576e+10);
        }

        function link(scope, elem, attrs, ctrl) {

            scope.$watch(attrs.ngModel, function (value) {

                if (testDateRegex(value) && getAge(value) > 5 && getAge(value) <= 14)
                    ctrl.$setValidity('date', true);
                else
                    ctrl.$setValidity('date', false);

            })
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            link: link
        }
    }
}());